import React, { useState } from 'react'
import axios from 'axios'
import { BulkUpdateZeroCostView } from './BulkUpdateZeroCostView'

export const BulkUpdateZeroCost = () => {
    const [text, setText] = useState()
    const [loading, setLoading] = useState()
    const [complete, setComplete] = useState()

    const onChangeText = (e) => {
        setText(e.target.value)
    }

    const onSubmit = () => {
        axios.post(process.env.REACT_APP_HOST +'api/zeroCosts/update', {
            params: {
                data: text
            }
        })
        .then((res) => {
            console.log(res)
            if(res.status === 200){
                setComplete(true)
            }
        })
    }

    

    return <BulkUpdateZeroCostView
        onChangeText={onChangeText}
        loading={loading}
        onSubmit={onSubmit}
        complete={complete}
    />
}